var map = {
	"./1af201d1-a8e1-4eac-86a0-ee67bf588dfc-min.webp": 4704,
	"./IMG_6106-min.webp": 3513,
	"./bef53e18-4a88-42c6-a0e0-e2a6b5ea1db9-min.webp": 1138
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1657;